<script lang="ts" setup>
const props = defineProps<{
  active?: boolean
}>()

const emit = defineEmits(['closePopup'])

const emitClose = () => {
  emit('closePopup')
}

useHead(() => {
  const { width } = useScrollbarWidth()
  return {
    bodyAttrs: {
      class: computed(() => (props.active ? 'overflow-hidden modal-open' : '')),
      style: `margin-right: ${width.value}px`,
    },
  }
})
</script>

<template lang="pug">
div(
  class="fixed z-50 w-screen h-screen top-0 left-0 flex items-center justify-center bg-blue-dark/90"
)
  div(
    class="flex relative z-10 w-full max-w-prose-wide h-screen md:h-auto max-h-screen md:rounded bg-grey-100 shadow-2xl"
  )
    div(class="flex w-full p-18 md:p-30 overflow-y-auto")
      slot
    div(class="absolute right-18 md:right-30 top-30")
      MaterialSymbol(
        class="close cursor-pointer text-grey-500"
        @click="emitClose"
        :size="30"
      ) close
  div(class="absolute z-1 w-full h-full" @click="emitClose")
</template>

<style lang="postcss" scoped>
.close {
  transition: all 0.2s ease;

  &:hover {
    @apply text-blue-dark;
  }
}
</style>
